// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CaesarСipher-board-logo {
  display: grid;
  grid-template-rows: auto 3vw 3vw;
  width: inherit;
  place-items: center;
}

.CaesarСipher-board-logo-image {
  place-self: end;
  position: relative;
  height: 20vw;
}

#CaesarСipher-board-logo-button {
  position: relative;
  left: 1.2vw;
}

#CaesarСipher-subtitle-board-logo {
  position: relative;
  left: 0.9vw;
}
`, "",{"version":3,"sources":["webpack://./src/TaskWindows/CaesarСipher/styles/Caesar%D0%A1ipherBoardLogo.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gCAAgC;EAChC,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb","sourcesContent":[".CaesarСipher-board-logo {\n  display: grid;\n  grid-template-rows: auto 3vw 3vw;\n  width: inherit;\n  place-items: center;\n}\n\n.CaesarСipher-board-logo-image {\n  place-self: end;\n  position: relative;\n  height: 20vw;\n}\n\n#CaesarСipher-board-logo-button {\n  position: relative;\n  left: 1.2vw;\n}\n\n#CaesarСipher-subtitle-board-logo {\n  position: relative;\n  left: 0.9vw;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
